/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropoundingFormatOptions
 */
export interface PropoundingFormatOptions {
    /**
     * 
     * @type {string}
     * @memberof PropoundingFormatOptions
     */
    specialInterrogatoriesRequestFormat?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropoundingFormatOptions
     */
    formInterrogatoriesRequestFormat?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropoundingFormatOptions
     */
    requestForProductionRequestFormat?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropoundingFormatOptions
     */
    requestForAdmissionRequestFormat?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropoundingFormatOptions
     */
    defaultRequestFormat?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropoundingFormatOptions
     */
    specialInterrogatoriesResponseFormat?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropoundingFormatOptions
     */
    formInterrogatoriesResponseFormat?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropoundingFormatOptions
     */
    requestForProductionResponseFormat?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropoundingFormatOptions
     */
    requestForAdmissionResponseFormat?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropoundingFormatOptions
     */
    defaultResponseFormat?: string | null;
}

export function PropoundingFormatOptionsFromJSON(json: any): PropoundingFormatOptions {
    return PropoundingFormatOptionsFromJSONTyped(json, false);
}

export function PropoundingFormatOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropoundingFormatOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specialInterrogatoriesRequestFormat': !exists(json, 'specialInterrogatoriesRequestFormat') ? undefined : json['specialInterrogatoriesRequestFormat'],
        'formInterrogatoriesRequestFormat': !exists(json, 'formInterrogatoriesRequestFormat') ? undefined : json['formInterrogatoriesRequestFormat'],
        'requestForProductionRequestFormat': !exists(json, 'requestForProductionRequestFormat') ? undefined : json['requestForProductionRequestFormat'],
        'requestForAdmissionRequestFormat': !exists(json, 'requestForAdmissionRequestFormat') ? undefined : json['requestForAdmissionRequestFormat'],
        'defaultRequestFormat': !exists(json, 'defaultRequestFormat') ? undefined : json['defaultRequestFormat'],
        'specialInterrogatoriesResponseFormat': !exists(json, 'specialInterrogatoriesResponseFormat') ? undefined : json['specialInterrogatoriesResponseFormat'],
        'formInterrogatoriesResponseFormat': !exists(json, 'formInterrogatoriesResponseFormat') ? undefined : json['formInterrogatoriesResponseFormat'],
        'requestForProductionResponseFormat': !exists(json, 'requestForProductionResponseFormat') ? undefined : json['requestForProductionResponseFormat'],
        'requestForAdmissionResponseFormat': !exists(json, 'requestForAdmissionResponseFormat') ? undefined : json['requestForAdmissionResponseFormat'],
        'defaultResponseFormat': !exists(json, 'defaultResponseFormat') ? undefined : json['defaultResponseFormat'],
    };
}

export function PropoundingFormatOptionsToJSON(value?: PropoundingFormatOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specialInterrogatoriesRequestFormat': value.specialInterrogatoriesRequestFormat,
        'formInterrogatoriesRequestFormat': value.formInterrogatoriesRequestFormat,
        'requestForProductionRequestFormat': value.requestForProductionRequestFormat,
        'requestForAdmissionRequestFormat': value.requestForAdmissionRequestFormat,
        'defaultRequestFormat': value.defaultRequestFormat,
        'specialInterrogatoriesResponseFormat': value.specialInterrogatoriesResponseFormat,
        'formInterrogatoriesResponseFormat': value.formInterrogatoriesResponseFormat,
        'requestForProductionResponseFormat': value.requestForProductionResponseFormat,
        'requestForAdmissionResponseFormat': value.requestForAdmissionResponseFormat,
        'defaultResponseFormat': value.defaultResponseFormat,
    };
}


